declare const __HUB_DEV_SERVER__: boolean | undefined;

/** True only on the local Vite dev server: never in a Stage/Production build or in tests. */
export const IS_HUB_DEV_SERVER = typeof __HUB_DEV_SERVER__ === 'boolean' && __HUB_DEV_SERVER__;

const ALERT_DEMO_KEY = 'lk.hub.alertDemo';

/**
 * The floating Demo alerts control is opt-in even on the dev server, so a local UAT on real data never has it over
 * the package page. `?alertDemo=1` turns it on for this browser, `?alertDemo=0` turns it off.
 */
export const isAlertDemoEnabled = (
  devServer: boolean = IS_HUB_DEV_SERVER,
  search: string = typeof window === 'undefined' ? '' : window.location.search,
): boolean => {
  if (!devServer) return false;
  const asked = new URLSearchParams(search).get('alertDemo');
  try {
    if (asked === '1') window.localStorage.setItem(ALERT_DEMO_KEY, '1');
    if (asked === '0') window.localStorage.removeItem(ALERT_DEMO_KEY);
    return window.localStorage.getItem(ALERT_DEMO_KEY) === '1';
  } catch {
    return asked === '1';
  }
};
